export default function textarea(element: HTMLDivElement) {
  const controlEl = element.querySelector<HTMLTextAreaElement>(
    "[data-rds-textarea-control]"
  );
  const counterEl = element.querySelector<HTMLSpanElement>(
    "[data-rds-textarea-counter]"
  );
  const autoGrowDataAttr = element.querySelector<HTMLTextAreaElement>(
    "[data-rds-textarea-autogrow]"
  );

  function initCounter(): void {
    if (controlEl) {
      const maxLength = Number(controlEl.getAttribute("maxLength"));
      if (maxLength && maxLength > 0) {
        const { value } = controlEl;
        updateCounter(`${maxLength - value.length}`);
      }
    }
  }

  function updateCounter(value: string): void {
    if (counterEl) {
      counterEl.textContent = value;
    }
  }

  function initAutoGrow(): void {
    if (controlEl && autoGrowDataAttr !== null) {
      controlEl.style.resize = "none";
      updateHeight(`${calcHeight(controlEl)}px`);
    }
  }

  function updateHeight(value: string): void {
    if (controlEl) {
      controlEl.style.height = value;
    }
  }

  function calcHeight(textareaEl: HTMLTextAreaElement): number {
    const borderWidth = Number(
      getComputedStyle(textareaEl)
        .getPropertyValue("border-width")
        .split("px")[0]
    );
    const roundedBorderWidth = Math.round(borderWidth);

    return textareaEl.scrollHeight + roundedBorderWidth * 2;
  }

  function handleInput(this: HTMLTextAreaElement): void {
    const maxLength = Number(this.getAttribute("maxLength"));
    if (counterEl && maxLength && maxLength > 0) {
      const currentCharacterCount = this.value.length;
      updateCounter(`${maxLength - currentCharacterCount}`);
    }
    if (autoGrowDataAttr !== null) {
      updateHeight("auto");
      updateHeight(`${calcHeight(this)}px`);
    }
  }

  function reset(): void {
    if (controlEl) {
      controlEl.value = "";

      if (autoGrowDataAttr !== null) {
        updateHeight("auto");
        updateHeight(`${calcHeight(controlEl)}px`);
      }

      if (counterEl) {
        const maxLength = Number(controlEl.getAttribute("maxLength"));
        updateCounter(`${maxLength}`);
      }
    }
  }

  function setup(): void {
    initCounter();
    initAutoGrow();
    if (controlEl) {
      controlEl.addEventListener("input", handleInput);
    }
  }

  setup();

  return {
    reset,
  };
}
